import { combineReducers } from 'redux';
import workflow from './workflow';

const createRootReducer = () => combineReducers({
  workflow,
});

export default createRootReducer;
